var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono usuario"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1812 2.90626C8.86999 2.8106 2.90124 8.59282 2.99999 15.6756C3.09749 22.4684 8.80686 27.9993 15.8187 28.0938C23.1312 28.1906 29.0987 22.4084 28.9987 15.3256C28.9025 8.53167 23.1931 3.00071 16.1812 2.90626ZM24.0825 22.7202C24.0576 22.7463 24.0271 22.7668 23.9931 22.7801C23.9591 22.7935 23.9225 22.7995 23.8859 22.7977C23.8493 22.7958 23.8136 22.7862 23.7812 22.7694C23.7489 22.7527 23.7207 22.7293 23.6987 22.7009C23.1397 21.9923 22.4551 21.3857 21.6769 20.9093C20.0856 19.9199 18.0694 19.375 16 19.375C13.9306 19.375 11.9144 19.9199 10.3231 20.9093C9.54491 21.3855 8.8603 21.9919 8.30124 22.7002C8.27927 22.7287 8.25112 22.7521 8.21877 22.7688C8.18642 22.7856 8.15067 22.7952 8.11405 22.7971C8.07743 22.7989 8.04084 22.7929 8.00687 22.7795C7.9729 22.7662 7.94238 22.7457 7.91749 22.7196C6.08353 20.8017 5.04467 18.2956 4.99999 15.6817C4.89811 9.78984 9.88874 4.85829 15.9731 4.84376C22.0575 4.82923 27 9.61546 27 15.5C27.0021 18.177 25.96 20.756 24.0825 22.7202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 8.71875C14.7675 8.71875 13.6532 9.16619 12.8613 9.97934C12.0694 10.7925 11.6738 11.9168 11.7632 13.1235C11.9444 15.5 13.845 17.4375 16 17.4375C18.155 17.4375 20.0519 15.5 20.2369 13.1241C20.3294 11.9289 19.9369 10.8149 19.1319 9.9866C18.3369 9.16922 17.2244 8.71875 16 8.71875Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.e4e069e2ca6e19434623828b4a0b4719.svg";
export { ForwardRef as ReactComponent };